<template>
  <div>
    <v-card>
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">{{$t(`rms.toolbar.tag.type.${this.tag_type}`)}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="onAdd()">{{$t('rms.button.add')}}</v-btn>
      </v-toolbar>
    </v-card>

    <add-tag-dialog
      ref="saveTagDialog"
      :activate="show_add_tag_dialog"
      @close="show_add_tag_dialog=false"
      :tags="list"
      :tag_type="tag_type"
      :countries="countries"
    ></add-tag-dialog>

    <template v-if="list">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('rms.field.search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="table_headers"
          :items="list"
          :search="search"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.slug }}</td>
            <td class="text-xs-left">
              <span
                v-if="props.item.is_published"
                class="green--text body-2"
              >{{$t('rms.drawer.admin.tags.list.status.published')}}</span>
              <span
                v-else
                class="red--text body-2"
              >{{$t('rms.drawer.admin.tags.list.status.unpublished')}}</span>
            </td>
            <td class="text-xs-left">
              <v-btn icon ripple>
                <v-icon color="info lighten-1" @click="onEdit(props.item)">$vuetify.icons.rms_edit</v-icon>
              </v-btn>
              <!-- <ConfirmationDialog
                :desc="'admin.config.tag.delete.confirmation.description'"
                :action="getDialogAction(props.item,'rms_delete','error')"
                :headline="'admin.config.tag.delete.confirmation.heading'"
                :button_type="'icon'"
              ></ConfirmationDialog>-->
            </td>
          </template>

          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{$t('rms.alert.search_not_found', {
              search: search
              })}}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import moment from "moment";
import AddTagDialog from "./Add";
import ConfirmationDialog from "@/components/ConfirmationDialog";
export default {
  name: "AdminTagsList",
  components: {
    AddTagDialog,
    ConfirmationDialog
  },
  data() {
    return {
      moment,
      search: "",
      show_add_tag_dialog: false,
      tag_type: null,
      pagination: {
        rowsPerPage: 25,
        sortBy: "name"
      },
      table_headers: [
        { text: i18n.t("rms.table.header.sn"), align: "left", sortable: false },
        {
          text: i18n.t("rms.table.header.name"),
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: i18n.t("rms.table.header.slug"),
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: i18n.t("rms.table.header.status"),
          align: "left",
          sortable: false,
          value: "title"
        },
        {
          text: i18n.t("rms.table.header.action"),
          align: "left",
          sortable: false
        }
      ],
      countries: null
    };
  },

  //get all the tags when params update
  beforeRouteUpdate(to, from, next) {
    this.tag_type = to.params.tag_type;
    this.getTags(to.params.tag_type);

    next();
  },

  mounted() {
    this.tag_type = this.$route.params.tag_type;
    this.getTags(this.tag_type);
    this.getCountries();
  },

  computed: {
    ...mapState({
      list(state) {
        return state.adminTag[this.$route.params.tag_type];
      }
    })
  },

  methods: {
    async getCountries() {
      this.countries = await this.$store.dispatch("country/list");
    },
    async getTags(type) {
      var response = await this.$store.dispatch("adminTag/list", {
        type
      });
    },
    
    async deleteTag(tag) {
      try {
        await this.$store.dispatch("adminTag/delete", tag);

        this.$store.dispatch("adminTag/list", {
          type: this.tag_type
        });

        this.$store.dispatch("app/showMessage", {
          message: i18n.t("message.success.deleted"),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    getDialogAction(update_status, btn_icon, btn_color) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        method: this.deleteTag,
        payload: update_status
      };
    },
    onEdit(tag) {
      (this.show_add_tag_dialog = true),
        this.$refs.saveTagDialog.onEdit(Object.assign({}, tag));
    },

    onAdd() {
      (this.show_add_tag_dialog = true),
        this.$refs.saveTagDialog.onAdd(this.tag_type);
    }
  }
};
</script>

